import {defaultDestination, defaultCountry, defaultPartner} from './../../../config/app-config';
import {addDays, defaultCheckinOffset, defaultCheckoutOffset} from '../../../utils/date-utils';

import {defaultRoomString} from '../../../config/app-config';

import {
  CommonActionTypes,
  UPDATE_QUERY,
  ICommonStoreState,
  UPDATE_SEGMENT_SLIDER_DATA,
  TOGGLE_LOADING_SEGMENT_SLIDER,
  RESET_SEGMENT_SLIDER,
  ERROR_LOADING_SEGMENT_SLIDER,
} from './types';

const initialState: ICommonStoreState = {
  country: defaultCountry,
  destination: defaultDestination,
  partner: defaultPartner,
  checkin: {date: addDays(new Date(), defaultCheckinOffset), isMidnight: false},
  checkout: {date: addDays(new Date(), defaultCheckoutOffset), isMidnight: false},
  roomString: defaultRoomString,
  segmentSliderApi: {
    isLoading: true,
    data: null,
    error: null,
  },
};

export default function srpPageReducer(state = initialState, action: CommonActionTypes) {
  switch (action.type) {
    case UPDATE_QUERY:
      return {
        ...state,
        ...action.actionData,
      };

    case UPDATE_SEGMENT_SLIDER_DATA:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          data: action.actionData,
        },
      };

    case TOGGLE_LOADING_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          isLoading: action.actionData,
        },
      };

    case ERROR_LOADING_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          ...state.segmentSliderApi,
          error: action.actionData,
          isLoading: false,
        },
      };

    case RESET_SEGMENT_SLIDER:
      return {
        ...state,
        segmentSliderApi: {
          isLoading: true,
          data: null,
        },
      };

    default:
      return state;
  }
}
